import { IconComponentsProps } from './types';

const CloseFilledIcon = ({ fill = 'currentColor', ...props }: IconComponentsProps) => (
  <svg width="16" height="16" viewBox="0 0 32 32" fill={fill} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9 l5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z" />
  </svg>
);

export default CloseFilledIcon;
